'use strict';

module.exports = ['$scope', 'ngDroUAA', 'ngDroUtilsNotify', function ($scope, ngDroUAA, ngDroUtilsNotify) {

        $scope.submit = function (isValid, next) {
            $scope.submitted = true;

            if (isValid) {
                /**
                 * Distinguo le operazioni a seconda che mi trovo in fase 
                 * di inserimento o di update dell'oggetto template.
                 */
                if (!$scope.company.id) {
                    ngDroUAA.Company.save($scope.company)
                            .then(function () {
                                ngDroUtilsNotify.insertSuccess($scope.company.name);
                                $scope.redirect(next);
                            })
                            .catch(function (err) {
                                ngDroUtilsNotify.insertError($scope.company.name,err);
                            })
                            .finally(function () {
                            });
                } else {
                    ngDroUAA.Company.update($scope.company)
                            .then(function () {
                                ngDroUtilsNotify.updateSuccess($scope.company.name);
                                $scope.redirect(next);
                            })
                            .catch(function (err) {
                                ngDroUtilsNotify.updateError($scope.company.name,err);
                            })
                            .finally(function () {
                            });
                }
            }
        };
    }];


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/components/company/companyDetail/tabs/company-form.js
// module id = 420
// module chunks = 0